import React from "react";

/**
 * Stratiq logos rendered inline as SVG.
 * Dark-mode only — fill defaults to white. Use forceColor="dark" to render dark fill
 * (only used for inverse contexts; not used currently since site is dark everywhere).
 */

export function LogoFull({ className = "", forceColor }) {
  const fill = forceColor === "dark" ? "#111111" : "#ffffff";
  const sub = "#888888";

  return (
    <svg
      viewBox="0 0 900 170"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Stratiq — AI & Business Advisory"
      role="img"
    >
      <rect x="8"  y="116" width="22" height="42"  rx="3" fill={fill} />
      <rect x="40" y="86"  width="22" height="72"  rx="3" fill={fill} />
      <rect x="72" y="48"  width="22" height="110" rx="3" fill={fill} />
      <circle cx="83" cy="31" r="13" fill="#E5503A" />
      <text x="110" y="132"
            fontFamily="'Barlow Condensed','Arial Black',sans-serif"
            fontWeight="800" fontSize="90" fill={fill} letterSpacing="1">
        STRATIQ
      </text>
      <text x="112" y="156"
            fontFamily="'Barlow',Arial,sans-serif"
            fontWeight="300" fontSize="13" fill={sub} letterSpacing="6">
        AI &amp; BUSINESS ADVISORY
      </text>
    </svg>
  );
}

export function LogoMark({ className = "", forceColor }) {
  const fill = forceColor === "dark" ? "#111111" : "#ffffff";

  return (
    <svg
      viewBox="0 0 180 158"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Stratiq"
      role="img"
    >
      <rect x="8"  y="116" width="22" height="42"  rx="3" fill={fill} />
      <rect x="40" y="86"  width="22" height="72"  rx="3" fill={fill} />
      <rect x="72" y="48"  width="22" height="110" rx="3" fill={fill} />
      <circle cx="83" cy="31" r="13" fill="#E5503A" />
    </svg>
  );
}
